import React from 'react'
import Header from '../Components/Header'
import Home from "./Home"
import Footer from "../Components/Footer"
import AsideL from "../Components/AsideL"
import AsideR from "../Components/AsideR"
import Acerca from './Acerca'
import Misconocimientos from './Misconocimientos'
import MisProyectos from './MisProyectos'
import Contactarme from './Contactarme'

const Spanish = () => {
  return (
    
    <div className=' bg-slate-800'>
        <Header/>
        <div className='flex w-full '>
            <div className='w-1/12 '>
                <AsideL/>
            </div>
            <div className='w-10/12 '>
                <div><Home /></div>
                <div><Acerca id="acerca"/></div>
                <div><Misconocimientos/></div>
                <div><MisProyectos/></div>
                <div><Contactarme/></div>
                
            </div>
            <div className='w-1/12 justify-center flex items-center h-screen '>
                <AsideR/>
            </div>
        </div>
        <Footer/>
    </div>
  )
}

export default Spanish